import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// View
import TopView from '../views/TopView.vue'
import SearchView from '../views/orders/SearchView.vue'
import DetailView from '../views/orders/DetailView.vue'
import CreateView from '../views/orders/CreateView.vue'
import MasterView from '../views/settings/MasterView.vue'
import ChangeCompanyInfoView from '../views/settings/ChangeCompanyInfoView.vue'
import ChangeNotifyView from '../views/settings/ChangeNotifyView.vue'
import HistoryView from '../views/settings/HistoryView.vue'
import ChangePasswordView from '../views/settings/ChangePasswordView.vue'
import LoginView from '../views/LoginView.vue'
import LoginOnDeviceView from '../views/LoginOnDeviceView.vue'
import ReminderView from '../views/ReminderView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import NotFound from '../views/errors/404View.vue'
import InternalError from '../views/errors/500View.vue'
// store
import { useUserStore, useDeviceStore } from '@/store/user'
import { useLoadingStore } from '@/store/loading'

const DEFAULT_TITLE = '家族葬のファミーユ 発注管理システム';

const routes: Array<RouteRecordRaw> = [
    // 認証後画面
    { path: '/', name: 'top', component: TopView, meta: { title: 'トップ' } },
    { path: '/orders', name: 'searchOrder', component: SearchView, meta: { title: '取引検索' } },
    { path: '/orders/detail/:orderId', name: 'orderDetail', component: DetailView, meta: { title: '取引詳細' } },
    //////// 取引新規作成処理は一時廃止 ////////////////////////////////////////////////////////////////////////////////
    //{ path: '/orders/create', name: 'createOrder', component: CreateView, meta: { title: '取引新規作成' } },    
    { path: '/settings', name: 'settings', component: MasterView, meta: { title: 'マスタ設定' } },
    { path: '/settings/company', name: 'settingCompany', component: ChangeCompanyInfoView, meta: { title: '会社情報変更' } },
    { path: '/settings/notify', name: 'settingNotify', component: ChangeNotifyView, meta: { title: '通知先変更' } },
    { path: '/settings/history', name: 'loginHistory', component: HistoryView, meta: { title: '履歴確認' } },
    { path: '/settings/password', name: 'changePassword', component: ChangePasswordView, meta: { allowNotActivated: true, title: 'パスワード変更' } },
    { path: '/login-device', name: 'loginOnDevice', component: LoginOnDeviceView, meta: { loginOnDevice: true, title: '端末初回ログイン' } },
    // 認証不要画面
    { path: '/login', name: 'login', component: LoginView, meta: { isPublic: true, title: 'ログイン' } },
    { path: '/reminder', name: 'reminder', component: ReminderView, meta: { isPublic: true, title: 'パスワード再発行' } },
    { path: '/reset-password/:accountId/:loginId/:rkey', name: 'resetPassword', component: ResetPasswordView, meta: { isPublic: true, title: 'パスワード再設定' } },
    { path: '/error', name: 'InternalError', component: InternalError, meta: { isPublic: true, title: '500' } },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { isPublic: true, title: '404' } },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const userStore = useUserStore();
    const deviceStore = useDeviceStore();
    const loadingStore = useLoadingStore();

    // ページ遷移時は必ずローディングを止める
    loadingStore.endLoading();

    // ログインしていない場合
    if (!userStore.isLogined) {
        if (to.matched.some(page => !page.meta.isPublic)) {
            if (userStore.isLogout) {
                // ログアウト後のログイン画面へリダイレクト
                next({ name: 'login' });
            } else {
                // 認証後のページへ遷移しようとした場合ログイン画面へリダイレクト
                next({ name: 'login', query: { redirect: to.fullPath } });
            }
            return;
        }
        // ログイン済みの場合
    } else {
        if (to.name == 'login') {
            // ログイン画面に遷移しようとした場合TOP画面へリダイレクト
            next({ name: 'top', });
            return;
        }

        if (to.matched.some(page => page.meta.isPublic)) {
            // 認証不要ページへ遷移する場合は、そのままリダイレクト
            next();
            return;
        }

        if (!userStore.isActivated && to.matched.some(page => !page.meta.allowNotActivated)) {
            // アクティベートが済んでいない場合、パスワード変更画面へリダイレクト
            next({ name: 'changePassword', });
            return;
        }

        if (userStore.isActivated &&
            !deviceStore.isLoginedOnDevice &&
            to.matched.some(page => !page.meta.loginOnDevice)) {
            // 端末(ブラウザ)での初回ログイン時の場合、通知送信画面へリダイレクト
            next({ name: 'loginOnDevice', query: { redirect: to.fullPath } });
            return;
        }
    }

    // 上記に当てはまらない場合、ページ遷移
    next();
});

router.afterEach((to) => {
    let title = to.meta.title as string;
    if (title != null && title != '') {
        title += " | " + DEFAULT_TITLE;
    } else {
        title = DEFAULT_TITLE;
    }
    document.title = title;
})

export default router
